export enum PendingTaskTypeKey {
    REJECTED_EKYC = 'rejectedEkyc',
    CLOSE_ACCOUNT = 'closeUserAccount',
}

export interface IPendingTaskDetails {
    [PendingTaskTypeKey.REJECTED_EKYC]?: {
        reason: string;
    };
    [PendingTaskTypeKey.CLOSE_ACCOUNT]?: {
        reason: string;
    };
}

export type TPendingTasks = {
    id?: string | number;
    nexTransactionId: string;
    createdAt: string;
    updatedAt: string;
    nexUserId: string;
    phoneNumber: string;
    status: PendingTaskStatus;
    transactionType: ETransactionType;
    referenceId?: string;
    adminId: number;
    adminMakerEmail: string;
    amount?: number;
    details: IPendingTaskDetails | null;
    rejectReason: string | null;
    ekycRejectReason: string | null;
    ekycId: string | null;
};

export enum PendingTaskStatus {
    PENDING = '0',
    APPROVED = '1',
    REJECTED = '2',
}

export enum ETransactionType {
    CASH_WITHDRAWAL = '0',
    RESET_PIN = '1',
    UNBLOCK_USER = '2',
    APPROVED_EKYC = '3',
    REJECTED_EKYC = '4',
    CLOSE_ACCOUNT = '5',
    ACTIVATE_USER = '6',
}

export enum EPendingTaskTypeName {
    CASH_WITHDRAWAL = 'Cash Withdrawal ',
    RESET_PIN = 'Reset Nex Cash PIN',
    UNBLOCK_USER = 'Unlock User',
    APPROVED_EKYC = 'Approve eKYC',
    REJECTED_EKYC = 'Reject eKYC',
    CLOSE_ACCOUNT = 'Close Account',
    ACTIVATE_USER = 'Activate User',
}

export type TPendingTaskApproveParams = {
    id: number;
};

export type TPendingTaskRejectParams = {
    id: number;
    reason: string;
};
